<template>
  <div class="d-flex">
    <template v-for="(entity, index) in totals">
      <div
        class="home-todo-item"
        style="max-width: 25%"
        :key="entity.id"
        :class="{ 'me-2': index !== 3 }"
      >
        <EntityCountCard
          :active="activeEntity === entity.id"
          :count="entity.value"
          :entityType="entity.id"
          @click="$emit('click', entity.id)"
        />
      </div>
    </template>
  </div>
</template>
<script>
import EntityCountCard from './EntityCountCard.vue'
export default {
  name: 'TodoEntityCounts',

  components: {
    EntityCountCard,
  },

  props: {
    activeEntity: String,
    totals: Array,
  },
}
</script>
<style lang="scss">
.home-todo-item {
  flex: 1 1 0;
  width: 0;
}
</style>
